import React from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';

import Button from '../../../Button';
import GridItem from '../../../GridItem';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

const GoOnButton = ({
  id,
  text,
  action,
  loading,
  disabled,
}) => {
  const cls = useStyles();

  return (
    <GridItem behavior="fixed">
      <div className={cls[mainCls]}>
        <Button
          id={id}
          value={text}
          className="tp-w--l"
          disabled={disabled}
          loading={loading}
          action={action}
        />
      </div>
    </GridItem>
  );
};

export default GoOnButton;

GoOnButton.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  action: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

GoOnButton.defaultProp = {
  id: null,
  text: 'Prosegui',
  action: () => {},
  loading: false,
  disabled: false,
};
